<template>
	<v-row v-if="Object.keys(certificate).length > 0">
		<v-col cols="12" class="">
			<v-card class="card-certificate elevation-0 rounded-xl hover-shadow pa-2" style="position: relative; height: 445px; width: 617px; overflow-x: auto; overflow-y: hidden;zoom: 98%;">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="primary"
							elevation="2"
							fab
							rounded
							class="btn-download"
							:loading="loadingSave"
							:disabled="loadingSave"
							v-bind="attrs"
							v-on="on"
							@click="saveToImage(myProfile, 'card-' + myProfile.member_network_code)"
						>
							<v-icon dense color="dark">mdi-download</v-icon>
						</v-btn>
					</template>
					<span>Simpan Gambar</span>
				</v-tooltip>

				<div class="d-flex flex-column align-center justify-center fill-height" style="height: 26.75rem; width: 600px;" :id="'card-' + myProfile.member_network_code">
					<v-img class="rounded-xl" :src="require('/public/assets/background/bg-certificate.png')"></v-img>
					<div class="certificate-name">{{ getName(certificate.member_name) }}</div>
					<div class="font-weight-medium certificate-value">{{ certificate.total_acc | toRupiah }}</div>
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
import html2canvas from 'html2canvas';
export default {
	data() {
		return {
			loadingSave: false
		}
	},
	props: {
		certificate: Object
	},
	computed: {
		...mapState('profil', ['myProfile']),
	},
	methods: {
		capitalize(word) {
			if (word !== '' || word.length > 0) {
				let strWord = word.toLowerCase()
				return strWord
					.split('')
					.map((letter, index) =>
						index ? letter.toLowerCase() : letter.toUpperCase(),
					)
					.join('');
      } else {
				return ''
			}
    },

		getName(name) {
			let name_split = name.split(" ");
			let name_true = ''
			if (name_split.length > 1) {
				if (name_split.length > 2) {
					if (name_split[0].length == 0) {
						const lastname = (name_split[2] != '') ? ' ' + this.capitalize(name_split[2]) : ''
						name_true = this.capitalize(name_split[1]) + lastname
					} else {
						const lastname = (name_split[1] != '') ? ' ' + this.capitalize(name_split[1]) : ''
						name_true = this.capitalize(name_split[0]) + lastname
					}
				} else {
					const lastname = (name_split[1] != '') ? ' ' + this.capitalize(name_split[1]) : ''
					name_true = this.capitalize(name_split[0]) + lastname
				}
			} else {
				name_true = this.capitalize(name_split[0])
			}
			return name_true
		},

		saveToImage(profile, id) {
			this.loadingSave = true
			var node = document.getElementById(id);
			var member = profile
					
			setTimeout(() => {
				html2canvas(node, { scale: 2 }).then(canvas => {
					this.saveAs(canvas.toDataURL(), 'certificate_' + member.member_network_code + '.png');
				});
			}, 6000);

		},
		saveAs(uri, filename) {
			var link = document.createElement('a');

			if (typeof link.download === 'string') {
				link.href = uri;
				link.download = filename;
				document.body.appendChild(link);

				//simulate click
				link.click();

				//remove the link when done
				document.body.removeChild(link);
			} else {
				window.open(uri);
			}

			this.loadingSave = false
		}
	}
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Tangerine:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;500;700&display=swap');

.certificate-name {
	font-family: 'Tangerine', cursive !important;
	font-weight: 700;
	font-size: 28pt;
	color: #e5cb9d;
	position: absolute;
	top: 40%;
	left: 17.5%;
}
.certificate-value {
	font-family: 'Roboto Slab', serif !important;
	font-weight: 500;
	font-size: 24pt;
	color: #e5cb9d;
	position: absolute;
	top: 60%;
	left: 18%;
}

.btn-download {
	display: block;
	position: absolute;
	top: 5px;
	left: 5px;
	z-index: 10;
	border-radius: 100%;
}

@media (max-width: 599px) {
	.certificate-name {
		top: 41%;
    left: 31.5%;
	}
	.certificate-value {
		top: 61%;
    left: 31.5%;
	}
}

@media (min-width: 618px) and (max-width: 991.98px) {
	.card-certificate {
		width: 100%!important;
		text-align: center;
		display: flex;
		justify-content: center;
	}
}
</style>